// in cases where values contain a differentiator to distinguish between duplicates, return the clean name
export const stripNameDifferentiator = (traitName: string) =>
  traitName.split('_differentiator(')[0];

// in cases where values contain a differentiator to distinguish between duplicates, return the type
export const getNameDifferentiator = (traitName: string) =>
  traitName.split('_differentiator(')[1]?.split(')')[0] || 'String';
